<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="'concierge'"
      [title]="pageTitle ? pageTitle : ''" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded && !errorMessage">
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="pageTitle ? pageTitle : 'Concierge'" />
        </div>
      </tidy-desktop-header>
    }

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (!loaded && !errorMessage) {
      <tidy-loader />
    }

    @if (loaded) {
      <tidy-alert>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="statusIcon"
            class="header-size" />
          @if (item.type !== 'support.concierge_task') {
            <tidy-text
              [header]="item?.header_text" />
          }
          @if (item.type === 'support.concierge_task') {
            <tidy-text
              [header]="item?.components?.[0]?.value?.subject" />
          }
        </tidy-row>
        @if (isJobIssue) {
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'You reported this issue on your'" /><span>&nbsp;</span>
              <tidy-text
                [body]="(this.item?.metadata?.custom?.job_datetime | parseDateTime:'MMM d') + ' ' + (this.item?.metadata?.custom?.job_datetime | parseDateTime:'h:mma')" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'job.'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'Tap here'"
                    (action)="goToJobDetails()"
                    class="link" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'for job details.'" />
                  </tidy-row>
                }
                @if (status !== 'completed' && status !== 'closed') {
                  <tidy-row>
                    @if (item?.components?.[0]?.value?.status === 'waiting_on_tidy') {
                      <tidy-text
                        [body]="'<i>Waiting on TIDY</i>'" />
                    }
                    @if (item?.components?.[0]?.value?.status === 'waiting_on_customer') {
                      <tidy-text
                        [body]="'<b><i>Waiting on You</i><b>'" />
                    }
                  </tidy-row>
                }
                @if (status === 'waiting_on_tidy' && item.type !== 'support.concierge_task') {
                  <tidy-row class="extra-top-padding">
                    <tidy-text
                      [body]="'We expect to reply within'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="replyTime" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'. We will reply both in the app and to your email'" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="email + '.'" />
                        </tidy-row>
                      }
                      @if (status === 'waiting_on_tidy' && item.type === 'support.concierge_task') {
                        <tidy-row class="extra-top-padding">
                          <tidy-text
                            [body]="'Our concierge will complete the task or reach out with any questions.'" />
                        </tidy-row>
                      }
                    </tidy-alert>
                    <tidy-button
                      [text]="'Reply'"
                      [action]="boundReply"
                      class="primary" />
                    @for (comment of item?.recent_comments; track comment.id) {
                      <tidy-card>
                        <tidy-row [alignLastItemRight]="true">
                          <tidy-text
                            [header]="((comment?.user_type === 'Customer' || comment?.user_type === 'customer' || comment?.user_type === 'CustomerMember') ? ('You' | translate) : ('TIDY Concierge' | translate))" />
                          <tidy-text
                            [helper]="(comment?.created_at | parseDateTime:'MMM d':'local') + ' ' + (comment?.created_at | parseDateTime:'h:mma':'local')" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [checkLineBreaks]="true"
                            [linkify]="true"
                            [body]="comment?.content" />
                        </tidy-row>
                        @if (comment?.attachments?.length > 0) {
                          <tidy-row>
                            <tidy-text
                              body="Attachments:" />
                          </tidy-row>
                          @for (attachment of comment?.attachments; track attachment) {
                            <tidy-row>
                              <tidy-text
                                [body]="attachment.split('/').pop()"
                                (action)="openAttachment(attachment)"
                                class="link" />
                            </tidy-row>
                          }
                        }
                        @if (comment?.user_type === 'AiTask' || comment?.user_type === 'AiFrontendAgent' || comment?.user_type === 'ConciergeUser') {
                          <tidy-row class="extra-top-padding">
                            <tidy-text
                              [smallHelper]="'Sent by Concierge'" />
                          </tidy-row>
                          <tidy-row class="vertical-align-center feedback-row">
                            <button
                              class="concierge-feedback-btn"
                              (click)="onCommentThumbClick(comment, 'positive')">
                              <img src="assets/svg/thumbs-up-outline.svg" />
                            </button>
                            <button
                              class="concierge-feedback-btn"
                              (click)="onCommentThumbClick(comment, 'negative')">
                              <img src="assets/svg/thumbs-down-outline.svg" />
                            </button>
                          </tidy-row>
                          @if (activeFeedbackCommentId === comment?.id || closingFeedbackCommentId === comment?.id) {
                            <div class="concierge-feedback-form" [class.closing]="closingFeedbackCommentId === comment?.id">
                              <tidy-row>
                                <tidy-text
                                  [smallHelper]="activeFeedbackType === 'positive' ? 'What did you like?' : 'What could be improved?'" />
                              </tidy-row>
                              <tidy-row>
                                <textarea
                                  class="concierge-feedback-textarea"
                                  [placeholder]="activeFeedbackType === 'positive' ? ('Tell us what was helpful...' | translate) : ('Tell us how we can do better...' | translate)"
                                  #feedbackTextarea></textarea>
                              </tidy-row>
                              <tidy-row [alignLastItemRight]="true">
                                <tidy-text
                                  [actionBody]="'Cancel'"
                                  (action)="cancelCommentFeedback()"
                                  class="link" />
                                <tidy-button
                                  [text]="isSubmittingFeedback ? 'Sending...' : 'Submit'"
                                  [action]="submitCommentFeedback.bind(this, comment)"
                                  class="primary"
                                  [smallButton]="true"
                                  [disabled]="isSubmittingFeedback" />
                              </tidy-row>
                            </div>
                          }
                        }
                      </tidy-card>
                    }
                  }

                </tidy-wrapper>
              </ng-template>

              <app-scroll-wrapper [templateContent]="content" [isfullWidthContent]="windowService.isDesktopRes" />
